import React, { useState } from 'react';

import { connect } from 'react-redux';

import Button from 'components/Button/Button';
import { actions as pointsBalanceActions } from 'coupon-common/src/modules/pointsBalance';
import { actions as productActions } from 'coupon-common/src/modules/products';
import { dispatchAsAsync, required } from 'coupon-common/src/utils';

const PayByPoints = ({ onConfirm, onClose, points, dispatch, product }) => {

    const [loading, setLoading] = useState(false);
    const COST_POINTS = 5*process.env.REACT_APP_POINTS_EXCHANGE_RATE;
    // 🔥 ALWAYS derived from latest Redux prop
    const businessPoints = points || 0;

    const cost = COST_POINTS;
    const remaining = businessPoints - cost;
    const hasEnoughPoints = businessPoints >= cost;

    const handlePointsPayment = async () => {
        try {
            setLoading(true);
            const result = await paymentByPoints()

            if (result.success) {
                dispatch(pointsBalanceActions.getPointsBalance())
                setLoading(false)
                onConfirm()
            }
        } catch (error) {
            alert("There was a problem processing the payment. Error is:" + error)
            setLoading(false)
        }
    }
    const paymentByPoints = async () => {
        const payload = { product_id: product.id }
        const res = await dispatchAsAsync(productActions.payByPoints(payload), dispatch);

        return res
    }

    return (
        <div>
            <div className="card mb-3 border">
                <div className="card-body">

                    <h5 className="mb-3">Points Payment</h5>

                    <div className="d-flex justify-content-between mb-2">
                        <span>Your balance</span>
                        <strong>{businessPoints} pts</strong>
                    </div>

                    <div className="d-flex justify-content-between mb-2">
                        <span>Cost</span>
                        <strong>- {cost} pts</strong>
                    </div>

                    <hr />

                    <div className="d-flex justify-content-between">
                        <span>Remaining</span>
                        <strong className={hasEnoughPoints ? "text-success" : "text-danger"}>
                            {remaining.toFixed(2)} pts
                        </strong>
                    </div>

                    {!hasEnoughPoints && (
                        <div className="alert alert-danger mt-3 mb-0">
                            Not enough points. Please switch to card payment.
                        </div>
                    )}

                </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", flexFlow: "wrap", gap: 10 }}>
                <Button type="button" disabled={loading} outline onClick={onClose}>
                    Decline
                </Button>

                <Button
                    onClick={handlePointsPayment}
                    disabled={!hasEnoughPoints || loading}
                    fetching={loading}
                >
                    Confirm
                </Button>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    points: state.pointsBalance.data.points,
});

export default connect(mapStateToProps)(PayByPoints);
